<ng-container *ngIf="showCustomAmmountSelection">
<ng-container  *ngIf="!needToShowDepositWIthBankId">
  <div class="crypto__balance">

    <div class="crypto__balance--panel">
      <div class="crypto__balance--head">
        <h3>{{'cryptoCashier.topupYourBalance' | translate}}</h3>
        <p>{{'cryptoCashier.buyCryptoCard' | translate}}</p>
      </div>
      <div class="crypto__balance--payment--logos">
        <span class="icon--master">
          <img src="{{siteUrlPath}}/{{mediaPath}}/crypto_logo/mastercard.svg" />
        </span>
        <span class="icon--visa">
          <img src="{{siteUrlPath}}/{{mediaPath}}/crypto_logo/visa.svg" />
        </span>
        <span class="icon--moonpay">
          <img src="{{siteUrlPath}}/{{mediaPath}}/crypto_logo/moonpay.svg" />
        </span>
      </div>
    </div>
  
  </div>
  <div class="crypto__choose--amount">
    <div class="crypto__heading">
      <h2>{{'cryptoCashier.chooseAmount' | translate}}</h2>
    </div> 
    <div class="crypto__choose--amount--panel">
      <div class="crypto__choose--amount--input">
        <div class="crypto-center">
          <span class="crypto--currency-symbol symbol-left" *ngIf='isCurrencyDefaultPosition'>{{userCurrencySymbol}}</span>
          <div #inputRef id="inputAmount" (focus)="showCaret($event)" class="input-content-editable" contenteditable="true"  inputmode="decimal"  appTwoDigitDecimaNumber (input)="checkMaxValue($event)">{{customAmount}}</div>
          <span class="crypto--currency-symbol symbol-right"  *ngIf='!isCurrencyDefaultPosition'>{{userCurrencySymbol}}</span>
        </div>
      </div>
      <div class="crypto__choose--amount--items">
        <button class="site-btn site__hosted--btn" [ngClass]="customAmount == valueOne*multipleValue ? 'active':''"  (click)="customAmountSet(inputRef,valueOne * multipleValue)">{{valueOne * multipleValue | currencyPipe:1}}</button>
        <button class="site-btn site__hosted--btn" [ngClass]="customAmount == valueTwo*multipleValue ? 'active':''" (click)="customAmountSet(inputRef,valueTwo * multipleValue)">{{valueTwo * multipleValue | currencyPipe:1}}</button>
        <button class="site-btn site__hosted--btn" [ngClass]="customAmount == valueThree*multipleValue ? 'active':''" (click)="customAmountSet(inputRef,valueThree * multipleValue)">{{valueThree*multipleValue | currencyPipe:1}}</button>
      </div>
    </div>
    <p>{{'cryptoCashier.disclaimerTxt' | translate}} </p>
  </div>
</ng-container>
<ng-container  *ngIf="needToShowDepositWIthBankId">
  <div class="crypto__balance">
  <div class="crypto__balance--panel">
    <div class="crypto__balance--head">
      <h3>{{'xSaleSite.xSaleTitle' | translate}}</h3>
      <p>{{'xSaleSite.xSaleDescription' | translate}}</p>
    </div>
    <div class="crypto__balance--payment--logos">
      <p>
        {{'xSaleSite.bankTitle' | translate}} 
        <span>{{'xSaleSite.bankTitleSecond' | translate}}</span>
      </p>
      <span class="icon--buumi">
        <img src="{{siteUrlPath}}/{{mediaPath}}/crypto_logo/x_sell_buumi.webp" />
      </span>
    </div>
  </div>
  </div>
</ng-container>
  
</ng-container>
<ng-container>
  <div id="moonpay-cashier" [ngClass]="showCustomAmmountSelection ? 'hide-iframe':'show-iframe'"></div>
</ng-container>